﻿import { IMatchHistory } from '../match-history';
import { IRequestForDonorReview } from '../request-for-donor-review';
import { IXmTracking } from '../xm-tracking';
import { IDonor } from '../donor';
import { IPosition } from '../position';
import { IReferral } from '../referral';
import { IDashContactDue } from '../dash-contact-due';
import { IMissingVoucherConsent } from '../missing-voucher-consent';
import { IPatientIntakeListItem } from '../patient-intake';
import { IMortalityRecipient } from './mortality-recipient';
import { IActionCenterWatrRequestWeek } from '../action-center-watr-request-week';
import { IActionCenterDiabeticRecipientFollowUp } from '../action-center-diabetic-recipients-follow-up';
import { IBloodDrawConfirmationContract } from './blood-draw-confirmation-contract';

export interface ICustomLogistics {
    centerId: number,
    outstanding: number
}

export interface IActionCenterToDo {
    matchOffers: IMatchHistory[];
    donorClearance: IMatchHistory[],
    preselectsOutstanding: number,
    requestsForDonorReview: IRequestForDonorReview[];
    xmResultsDueToday: IXmTracking[],
    confirmReimbursementDonations: string[],
    missingVoucherHolders: IDonor[],
    customLogistics: ICustomLogistics[],
    pendingRccaps: number,
    stagnantMicrositeUpdates: number,
    inactiveDonorsInRange: IDonor[],
    donorEvalOutOfDate: IDonor[],
    pendingRecipientReferrals: IReferral[],
    pendingPatientIntakeReferrals: IPatientIntakeListItem[],
    abWaitListPatients: IAbWaitList[],
    dashToDo: IDashContactDue[],
    flaggedForVoucherDonation: IDonor[],
    outstandingInternalDirectSwaps: IPosition[],
    missingVoucherConsents: IMissingVoucherConsent[],
    mortalityRecipients: IMortalityRecipient[],
    outstandingDonorReimbursements: IActionCenterWatrRequestWeek[],
    isDiabeticRecipientFollowUps: IActionCenterDiabeticRecipientFollowUp[],
    confirmSerologyBloodDraw: IBloodDrawConfirmationContract[],
    confirmBloodDrawCompletion: IBloodDrawConfirmationContract[],
    pendingPatientIntakeTransfers: IPatientIntakeListItem[]
}

export interface IAbWaitList {
    centerId: number,
    centerAlias: string,
    hasAbWaitListPatients: boolean,
    showHasAbWaitListPatients: boolean
}

export interface IAdminActionCenterToDo {
    matchOffers: number;
    donorClearance: number,
    preselectsOutstanding: number,
    stagnantMicrositeUpdates: number,
    requestsForDonorReview: number;
    xmResultsDueToday: number,
    confirmReimbursementDonations: number,
    missingVoucherHolders: number,
    customLogistics: number,
    pendingRccaps: number,
    inactiveDonorsInRange: number,
    donorEvalOutOfDate: number,
    pendingRecipientReferrals: number,
    abWaitListPatients: number,
    dashToDo: number,
    flaggedForVoucherDonation: number,
    outstandingInternalDirectSwaps: number,
    missingVoucherConsents: number,
    patientIntakeReferrals: number,
    mortalityRecipients: number
}

export interface IActionCenterItem {
    centerId: number,
    count: number
}